import React, { useState } from "react";
import { NotificationManager } from "react-notifications";
import Advise_mo from "../../../assets/images/Advise/Advise_mo.webp";
import Advise_pc from "../../../assets/images/Advise/Advise_pc.webp";

import bonc from "../../../assets/images/Advise/bonc.webp";
import { CiBoxList } from "react-icons/ci";

import axios from "axios";

import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaBuilding,
  FaLock,
} from "react-icons/fa";

export default function Advise() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    center: "",
    role: "",
    servicePackage: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const { name, email, phone, center, role, servicePackage } = formData;
    if (!name || !email || !phone || !center || !role || !servicePackage) {
      NotificationManager.error("Vui lòng điền đầy đủ thông tin!", "Lỗi", 5000);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm(); // Kiểm tra tính hợp lệ của form
    if (!isValid) return;

    setIsLoading(true);

    try {
      // Chuẩn bị dữ liệu gửi đi
      const rowData = [
        formData.name, // Họ và tên
        formData.email, // Email
        formData.phone, // Số điện thoại
        formData.center, // Tên trung tâm
        formData.role, // Chức vụ
        formData.servicePackage, // Gói dịch vụ
        new Date().toLocaleString(), // Thời gian đăng ký
      ];
      console.log("post data");
      // Gửi dữ liệu lên Google Sheets
      const response = await axios.post(
        "https://api-bluerise.bluerise.com.vn/contact-us",
        {
          values: rowData,
        }
      );

      // Kiểm tra phản hồi để chắc chắn việc gửi thành công
      if (response.status === 200 && response.data) {
        NotificationManager.success(
          "Dữ liệu đã được gửi lên Google Sheets!",
          "Thành công"
        );

        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          center: "",
          position: "",
          service: "",
        });
        setIsModalOpen(false);
      } else {
        NotificationManager.error("Lỗi khi gửi dữ liệu lên Google Sheets!");
      }
    } catch (error) {
      console.error("Error writing to Google Sheets:", error);
      NotificationManager.error(
        "Đã xảy ra lỗi khi gửi dữ liệu lên Google Sheets!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${
          window.innerWidth < 768 ? Advise_mo : Advise_pc
        })`,
      }}
    >
      <div className="block md:hidden">
        <div className="w-full container mx-auto px-[20px] py-[20px] grid grid-cols-1 items-center">
          <div className="w-full flex flex-col gap-3">
            <div className="w-full flex flex-col gap-1">
              <p className="text-[28px] font-semibold text-white">
                Sẵn sàng để trung tâm của bạn{" "}
                <span className="text-[28px] font-semibold text-[#FDC559]">
                  phát triển
                </span>{" "}
                vượt trội ?
              </p>
              <p className="text-[16px] text-white font-normal">
                Hãy để Blue Rise đồng hành cùng bạn trong việc tối ưu hóa quy
                trình quản lý và nâng cao chất lượng dịch vụ.
              </p>
            </div>
            <div className="border border-white bg-white rounded-[16px] w-full px-[24px] py-[40px] flex flex-col gap-3">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col gap-2 w-full text-[28px] font-semibold text-black">
                  <p>Đăng ký nhận tư vấn miễn phí</p>
                  <p>Dùng thử BlueRise ngay hôm nay</p>
                </div>
                <div>
                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaUser className="text-gray-500 mr-2" />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nhập họ và tên của bạn"
                      className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaEnvelope className="text-gray-500 mr-2" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Nhập email của bạn"
                      className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaPhone className="text-gray-500 mr-2" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Nhập số điện thoại của bạn"
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaBuilding className="text-gray-500 mr-2" />
                    <input
                      type="text"
                      name="center"
                      value={formData.center}
                      onChange={handleChange}
                      placeholder="Nhập tên trung tâm bạn đang làm việc"
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaLock className="text-gray-500 mr-2" />
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    >
                      <option value="">Chức vụ của bạn</option>
                      <option value="Giám đốc Trung Tâm">
                        Giám đốc Trung Tâm
                      </option>
                      <option value="Quản lý Trung Tâm">
                        Quản lý Trung Tâm
                      </option>
                      <option value="Giáo viên">Giáo viên</option>
                      <option value="Gia sư">Gia sư</option>
                      <option value="Học sinh">Học sinh</option>
                      <option value="Trợ giảng">Trợ giảng</option>
                    </select>
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <CiBoxList className="text-gray-500 mr-2" />
                    <select
                      name="servicePackage"
                      value={formData.servicePackage}
                      onChange={handleChange}
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    >
                      <option value="">Chọn gói dịch vụ cần tư vấn</option>
                      <option value="Basic">Basic</option>
                      <option value="Premium">Premium</option>
                      <option value="Unlimited">Unlimited</option>
                    </select>
                  </div>
                </div>
                <div className="w-full flex items-center justify-center">
                  <button
                    type="submit"
                    className="w-full md:w-[323px] bg-bluer h-[52px] text-white rounded-[30px] flex items-center justify-center hover:bg-[#032478]"
                  >
                    Nhận tư vấn miễn phí
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="flex items-center justify-center w-full">
            <img
              src={bonc}
              alt="left image"
              className="hidden md:block w-[80%] h-auto object-cover"
            />
            <img
              src={bonc}
              alt="right image"
              className="w-full h-auto object-cover block md:hidden"
            />
          </div>
        </div>
      </div>

      <div className="hidden md:block container mx-auto px-[20px] py-[20px]">
        <div className="grid grid-cols-2 md:grid-cols-1 lg:grid-cols-2 w-full items-center justify-center gap-3">
          <div className="w-full flex flex-col items-center justify-center">
            <div className="w-full flex flex-col gap-3">
              <div className="w-full flex flex-col gap-1">
                <p className="text-[28px] font-semibold text-white">
                  Sẵn sàng để trung tâm của bạn{" "}
                  <spam className="text-[28px] font-semibold text-[#FDC559]">
                    phát triển
                  </spam>{" "}
                  vượt trội ?
                </p>
                <p className="text-[16px] text-white font-normal">
                  Hãy để Blue Rise đồng hành cùng bạn trong việc tối ưu hóa quy
                  trình quản lý và nâng cao chất lượng dịch vụ.
                </p>
              </div>
              <div className="flex items-center justify-center w-full">
                <img
                  src={bonc}
                  alt="le"
                  className="hidden md:block w-[80%] h-auto object-cover"
                />
                <img
                  src={bonc}
                  alt="ri"
                  className="w-full h-auto object-cover block md:hidden"
                />
              </div>
            </div>
          </div>
          <div>
            {" "}
            <div className="border border-white bg-white rounded-[16px] w-full px-[24px] py-[40px] flex flex-col gap-3">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col gap-2 w-full text-[28px] font-semibold text-black">
                  <p>Đăng ký nhận tư vấn miễn phí</p>
                  <p>Dùng thử BlueRise ngay hôm nay</p>
                </div>
                <div>
                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4 mt-4">
                    <FaUser className="text-gray-500 mr-2" />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nhập họ và tên của bạn"
                      className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaEnvelope className="text-gray-500 mr-2" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Nhập email của bạn"
                      className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaPhone className="text-gray-500 mr-2" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Nhập số điện thoại của bạn"
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaBuilding className="text-gray-500 mr-2" />
                    <input
                      type="text"
                      name="center"
                      value={formData.center}
                      onChange={handleChange}
                      placeholder="Nhập tên trung tâm bạn đang làm việc"
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    />
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <FaLock className="text-gray-500 mr-2" />
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    >
                      <option value="">Chức vụ của bạn</option>
                      <option value="manager">Giám đốc Trung Tâm</option>
                      <option value="staff">Quản lý Trung Tâm</option>
                      <option value="teacher">Giáo viên</option>
                      <option value="tutor">Gia sư</option>
                      <option value="student">Học sinh</option>
                      <option value="assistant">Trợ giảng</option>
                    </select>
                  </div>

                  <div className="flex items-center border border-gray-300 rounded-lg p-2 mb-4">
                    <CiBoxList className="text-gray-500 mr-2" />
                    <select
                      name="servicePackage"
                      value={formData.servicePackage}
                      onChange={handleChange}
                      className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                    >
                      <option value="">Chọn gói dịch vụ cần tư vấn</option>
                      <option value="basic">Basic</option>
                      <option value="premium">Premium</option>
                      <option value="unlimited">Unlimited</option>
                    </select>
                  </div>
                </div>
                <div className="w-full flex items-center justify-center">
                  <button
                    type="submit"
                    className="w-full md:w-[323px] bg-bluer hover:bg-pa h-[52px] text-white rounded-[30px] flex items-center hover:bg-[#032478] justify-center "
                  >
                    Nhận tư vấn miễn phí
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
